import { Controller } from "@hotwired/stimulus"

// Controller for recurring task delete menu
// Shows options to delete just this task or this + all future
export default class extends Controller {
  static targets = ["menu"]

  toggle(event) {
    event.stopPropagation()
    this.menuTarget.classList.toggle("hidden")

    // Close when clicking outside
    if (!this.menuTarget.classList.contains("hidden")) {
      this.boundClose = this.closeOnClickOutside.bind(this)
      document.addEventListener("click", this.boundClose)
    }
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.add("hidden")
      document.removeEventListener("click", this.boundClose)
    }
  }

  disconnect() {
    if (this.boundClose) {
      document.removeEventListener("click", this.boundClose)
    }
  }
}
